import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification"
export default class extends Controller {
  static targets = ["container"]
  static values = { 
    autoDismiss: { type: Boolean, default: true },
    duration: { type: Number, default: 5000 }
  }

  connect() {
    console.log("Notification controller connected")
    
    // Auto-dismiss if enabled
    if (this.autoDismissValue) {
      this.setupAutoDismiss()
    }
  }

  setupAutoDismiss() {
    setTimeout(() => {
      this.dismiss()
    }, this.durationValue)
  }

  dismiss() {
    if (this.hasContainerTarget) {
      this.containerTarget.remove()
    } else {
      this.element.remove()
    }
  }

  // Instance method to show notification
  show(message, type = 'info', options = {}) {
    const notification = this.createNotificationElement(message, type, options)
    document.body.appendChild(notification)
    return notification
  }

  createNotificationElement(message, type, options) {
    const alertDiv = document.createElement('div')
    alertDiv.className = `alert alert-${type} alert-dismissible fade show position-fixed`
    alertDiv.style.cssText = 'top: 20px; right: 20px; z-index: 9999; min-width: 300px;'
    
    alertDiv.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `
    
    // Auto-dismiss
    if (options.autoDismiss !== false) {
      setTimeout(() => {
        alertDiv.remove()
      }, options.duration || 5000)
    }
    
    return alertDiv
  }
}
